<template>
  <main class="container-fluid mb-110">
    <div class="row newTable select">
      <div class="col-12 search mb-3">
        <div class="titleStyle mt-5 mb-3">選擇一位戶長，並調整成員身份</div>
        <div class="subTitleStyle mb-1">
          {{
            LastFamilyResult.length === 1
              ? "因剩餘成員為1人，此成員預設成為戶長"
              : "因原家戶戶長已重新歸戶，需指定一位新戶長"
          }}
        </div>
      </div>
      <div class="col-12">
        <mv-add-family-modify
          @save-items-data="checkDataM"
          :familyrlType="'A'"
          ref="mvAddFamilyModify"
          :selectedFamily="[]"
        />
      </div>
      <fixed-bottom>
        <template slot="@function">
          <div class="actions text-right">
            <a
              @click="$router.push({ name: 'relation' })"
              class="btn btn-default btn-custStyle mr-3"
              >取消</a
            >
            <a @click="changeFamilyLeaderM" class="btn btn-primary btn-custStyle">確認</a>
          </div>
        </template>
      </fixed-bottom>
      <!-- 打開遮罩 -->
      <mv-mask :open="mvMaskOpen" :content="maskContent" />
    </div>
  </main>
</template>

<script>
import moment from "moment";
import Avatar from "@/desktop/components/Avatar";
import { mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
import { mapGetters } from "vuex";
import {
  getFamilyMemberBycondition,
  getAllHouseholderBySales,
  changeFamilyLeader,
  addMembersToFamily,
  getFamilyMemberByCsidNo,
} from "@/service";
import mvAddFamilyModify from "@/desktop/views/mv/components/mvAddFamilyModify";
import mvInfo from "@/desktop/views/mv/components/mvInfo";
import mvMask from "@/desktop/views/mv/components/mvMask";
import { log } from "util";
import FixedBottom from "@/desktop/views/mv/components/modal/fixedBotton";

export default {
  name: "changeFamilyLeader",
  mixins: [commonMixin],
  data() {
    return {
      //上頁選擇戶長
      selectedHolder: this.$route.params.selectedHolder,
      prevRoute: "",
      //遮罩
      mvMaskOpen: false,
      //遮罩字樣
      maskContent: "",
    };
  },
  components: { Avatar, mvAddFamilyModify, mvMask, mvInfo, FixedBottom },
  computed: {
    ...mapGetters([
      "BaseUrl",
      "LastFamilyResult",
      "FamilyResultFilter",
      "UserInfo",
    ]),
  },
  methods: {
    moment,
    ...mapActions([
      "updateUserItems",
      "updateAllHolderSearchData",
      "setPageLock",
    ]),
    checkDataM(val) {
      if (val == "true") {
        this.maskContent = "資料更新中，請稍候...";
        this.panelOpen("mvMaskOpen");
        changeFamilyLeader(
          this.UserInfo.id,
          this.LastFamilyResult,
          this.selectedHolder,
          this.FamilyResultFilter
        ).then((result) => {
          if (result.header && result.header.status == "200") {
            getFamilyMemberByCsidNo(this.UserInfo.id, this.selectedHolder).then(
              (csidresult) => {
                if (csidresult.header && csidresult.data) {
                  var familyLeader = csidresult.data.filter((obj) => {
                    return obj.familyrl === 0;
                  });
                  this.$toast.info({ title: "歸戶成功" });
                  this.updateUserItems(familyLeader[0]);
                  localStorage.userItems = JSON.stringify(familyLeader[0]);
                  if (this.$store.state.isPageFromMv === false) {
                    this.$router.push({ name: 'customer-detail-2' });
                  } else {
                    this.$router.push({ name: 'familyRelation' });
                  }
                  this.panelClose("mvMaskOpen");
                }
              }
            );
          } else {
            this.$toast.info({ title: "歸戶失敗" });
            this.panelClose("mvMaskOpen");
          }
        });
      }
    },
    changeFamilyLeaderM() {
      this.$refs.mvAddFamilyModify.saveItems();
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
};
</script>
<style lang="scss" scoped>
.titleStyle {
  font-family: PingFangTC;
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #027a39;
}
.subTitleStyle {
  font-family: PingFangTC;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #323a45;
}
.mb-110 {
  margin-bottom: 110px;
}
.btn-custStyle {
  padding-top:9px !important;
  width:120px;
  height: 40px;
}
</style>